var React = require('react');

function FeatherCheckColorable (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17,9,9.438,16.563,6,13.125","transform":"translate(-4.939 -7.939)","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

FeatherCheckColorable.defaultProps = {"width":"13.121","height":"9.373","viewBox":"0 0 13.121 9.373"};

module.exports = FeatherCheckColorable;

FeatherCheckColorable.default = FeatherCheckColorable;
